import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ApiState {
  baseURL: string
}

const initialState: ApiState = {
  baseURL:  process.env.REACT_APP_CASA_ARCANA_API_BASE_URL || 'http://127.0.0.1:8000',
}

const apiSlice = createSlice({
  name: 'api',
  initialState,
  reducers: {
    setBaseURL: (state, action: PayloadAction<string>) => {
      state.baseURL = action.payload
    },
  },
})

export const { setBaseURL } = apiSlice.actions
export default apiSlice.reducer
